import React, { Component } from 'react'
import Parse from 'html-react-parser'
import PropTypes from 'prop-types'
import RichText from './RichText'
import classNames from 'classnames'
import Button from '@components/Button'
import { StaticQuery, graphql } from 'gatsby'
import * as styles from '~/styles/components/newsletter.module.scss'
import * as editorStyles from '~/styles/components/editor.module.scss'

class Newsletter extends Component {
  render () {
    return (
      <StaticQuery
        query={query} render={({ newsletter }) => (
          <section className={classNames(styles.newsletter, 'section section-newsletter')}>
            <div className="grid-container">
              <div className={styles.inner}>
                <div className={classNames(styles.content, 'grid-x')}>
                  <div className="cell smedium-10 smedium-offset-1 medium-offset-1 medium-8 large-5">
                    <span className={classNames(styles.icon, 'icon')}>
                      {Parse('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 24"><defs><linearGradient x1="28.675%" y1="27.778%" x2="62.634%" y2="72.222%" id="sprite-envelope-newsletter"><stop stop-color="#00FF4C" offset="0%"/><stop stop-color="#1DA1F2" offset="100%"/></linearGradient></defs><path d="M1.6 0C.734 0 0 .734 0 1.6v20.8c0 .866.734 1.6 1.6 1.6h32.8c.866 0 1.6-.734 1.6-1.6V1.6c0-.866-.734-1.6-1.6-1.6H1.6zm2.375 2.4h28.05L18 14.425 3.975 2.4zM2.4 4.188L17.225 16.9a1.2 1.2 0 001.55 0L33.6 4.188V21.6H2.4V4.188z" fill="#000000" fill-rule="nonzero"/></svg>')}
                    </span>

                    <h3 className={styles.title}>
                      {newsletter.title}
                    </h3>

                    {newsletter.description && (
                      <div className={classNames(styles.text, editorStyles.editor)}>
                        <RichText json={JSON.parse(newsletter.description.raw)} />
                      </div>
                    )}

                    <Button
                      className={classNames(styles.cta)}
                      onClick={this.props.onClick}
                      aria-label="Sign up to newsletter"
                      track={{
                        category: 'intent-pjc-NewsletterSubscription',
                        action: 'Click',
                        label: newsletter.buttonLabel
                      }}
                      fbTrack={{
                        name: 'IntentNewsletterSubscription'
                      }}
                    >
                      {newsletter.buttonLabel}
                    </Button>
                  </div>
                </div>

                <span className={classNames(styles.heart, 'show-for-large')} aria-hidden="true">
                  <img src={'/logo-heart.png'} aria-hidden="true" alt="Heart Logo" />
                </span>
              </div>
            </div>
          </section>
        )}
      />
    )
  }
}

export const query = graphql`
  query {
    newsletter: contentfulNewsletter(title: {regex: "/^(?!.*(sample))/gi"}) {
      title
      description {
        raw
      }
      buttonLabel
    }
  }
`

Newsletter.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default Newsletter
